import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const FacebookSolidSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { d: "M13.3332 22.9164C18.7796 22.2583 23 17.6202 23 11.9963C23 5.92121 18.0751 0.996338 12 0.996338C5.92487 0.996338 1 5.92121 1 11.9963C1 17.1551 4.55122 21.4845 9.34242 22.6731V15.3579H7.07202V11.9963H9.34242V10.5443C9.34242 6.79988 11.0364 5.06628 14.7104 5.06628C15.4056 5.06628 16.6068 5.20268 17.0996 5.33908V8.38828C16.84 8.36188 16.3868 8.34868 15.828 8.34868C14.024 8.34868 13.3288 9.03068 13.3288 10.8083V11.9963H16.9236L16.3076 15.3579H13.3332V22.9164Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const FacebookSolidSize24 = hoc(forwardRef(FacebookSolidSize24Component), 'FacebookSolidSize24');

export { FacebookSolidSize24 as default };
//# sourceMappingURL=FacebookSolidSize24.js.map
